import * as React from 'react';
import { Component } from '../../lib/component';
import { ContentHeader } from '../header/content';
import { px } from 'csx';
import { style } from 'typestyle';
import {colorWhite} from '../../theme/color';
import {ArtistSchema, ReleaseSchema, TrackSchema} from '../../types/schema';
import {ImagePreloader} from '../../types/fn';
import {Loading} from '../loading/loading';
import {formatYear} from '../../lib/date';

export interface ArtistHeaderProps {
  loading: boolean;
  artist: ArtistSchema;
  release?: ReleaseSchema;
  tracks: Array<TrackSchema>;

  firstTrack: TrackSchema;
  currentTrack: TrackSchema;
  isPlaying: boolean;

  preload: ImagePreloader;
  onPause(): any;
  onPlay(): any;
  onLoadImmediate(track: TrackSchema): any;
}

export class ArtistHeader extends Component<ArtistHeaderProps> {
  render() {
    const { props } = this;

    const imageIdentity = props.release
      ? props.release.images
        ? props.release.images.identity
        : null
      : props.artist && props.artist.images
        ? props.artist.images.identity
        : null;

    const headerProps = {
      loading: props.loading,
      imageIdentity,
      preload: props.preload,
      noOverlay: true,
    };

    const title = props.loading
      ? <Loading size={48} light={true} />
      : props.release
        ? props.release.title
        : props.artist.name;

    return (
      <ContentHeader {...headerProps}>
        <h1>{title}</h1>
        {props.release && <h2>{props.artist.name}</h2>}
        {!props.loading && !props.release && ArtistHeader.renderFormed(props.artist)}
        {!props.loading && props.release && ArtistHeader.renderReleased(props.release)}
      </ContentHeader>
    )
  }

  static renderFormed(artist: ArtistSchema) {
    if (!artist.formed && !artist.hometown) return null;

    return (
      <div className={formed}>
        {ArtistHeader.getFormedText(artist)}
      </div>
    )
  }

  static renderReleased(release: ReleaseSchema) {
    if (!release.release_date && !release.release_date) return null;

    return (
      <div className={formed}>
        Released {formatYear(new Date(release.release_date.timestamp * 1000))}
      </div>
    )
  }

  static getFormedText(artist: ArtistSchema) {
    switch (true) {
      case (!artist.formed && !artist.hometown):
        return null;

      case (!!artist.formed && !artist.hometown):
        return `Formed ${artist.formed}`;

      case (!artist.formed && !!artist.hometown):
        return `Formed in ${artist.hometown}`;

      case (!!artist.formed && !!artist.hometown):
        return `Formed in ${artist.hometown}, ${artist.formed}`;
    }
  }

  static styles = {
    play: style({
      position: 'absolute',
      bottom: px(-28),
      right: px(24),
      $nest: {
        '& svg': {
          height: px(16)
        }
      }
    })
  }
}

const formed = style({
  fontSize: px(14),
  color: colorWhite.toString(),
  margin: '0 0 0 2px'
});